import {
  ALL_WEEK_DAYS,
  DATE_FORMAT_STYLE_DMY,
  DATE_FORMAT_STYLE_MDY,
  DATE_FORMAT_STYLE_YMD,
  DateFormatStyle,
  IWorkingLocationPresenceType,
  PresenceType,
  WeekDayNames
} from "@gettactic/api";
import { format } from "date-fns";
import * as yup from "yup";

const shape = {
  name: yup
    .string()
    .required("A profile name is required")
    .min(1, "Name too short. Requires a minimum of 1 characters.")
    .max(255, "Name too long. Allows a maximum of 255 characters."),
  about: yup
    .string()
    .optional()
    .max(255, "Field is too long. Allows a maximum of 255 characters."),
  phone: yup
    .string()
    .optional()
    .max(255, "Field is too long. Allows a maximum of 255 characters."),
  title: yup
    .string()
    .optional()
    .max(255, "Field is too long. Allows a maximum of 255 characters."),
  birthdate: yup.string().optional(),
  location: yup.string().optional(),
  time_zone: yup.string().optional(),
  default_office_id: yup
    .object()
    .shape({ label: yup.string(), value: yup.string() }),
  default_floor_id: yup
    .object()
    .shape({ label: yup.string(), value: yup.string() }),
  default_presence_type: yup
    .object()
    .shape({ label: yup.string(), value: yup.string() })
};

export type PresenceTypeByDay = {
  [idx in WeekDayNames]: IWorkingLocationPresenceType | string;
};

export type EditProfileFormType = {
  name: string;
  about: string;
  phone: string;
  title: string;
  birthdate: Date;
  location: string;
  time_zone: string;
  default_office_id: string | null;
  default_floor_id: { label: string; value: string } | null;
  default_presence_type: {
    label: string;
    value: PresenceType | undefined;
  } | null;
  default_presence_type_by_day: PresenceTypeByDay;
  date_format: { label: JSX.Element; value: DateFormatStyle };
};

export const shapeDefaultPresenceTypeByDay = {};

ALL_WEEK_DAYS.forEach(
  //@ts-expect-error shapeDefaultPresenceTypeByDay not typed
  (day) => (shapeDefaultPresenceTypeByDay[day] = yup.string().optional())
);

export const schemaEditProfile = yup
  .object()
  .shape({ ...shape, days: yup.object({ ...shapeDefaultPresenceTypeByDay }) });

type DateFormatOptionsAvailable = "MM/dd/yyyy" | "dd/MM/yyyy" | "yyyy-MM-dd";
type DateFormatOptionProps = {
  dateFormat: DateFormatOptionsAvailable;
};

const DateFormatOption = ({ dateFormat }: DateFormatOptionProps) => {
  return (
    <span className="flex items-baseline space-x-4 uppercase">
      <span>{format(new Date(), dateFormat)}</span>
      <span className="text-center align-center text-gray-500 text-sm">
        {dateFormat}
      </span>
    </span>
  );
};
export const dateFormatOptions: readonly {
  label: JSX.Element;
  value: DateFormatStyle;
}[] = Object.freeze([
  {
    label: <DateFormatOption dateFormat={"MM/dd/yyyy"} />,
    value: DATE_FORMAT_STYLE_MDY
  },
  {
    label: <DateFormatOption dateFormat={"dd/MM/yyyy"} />,
    value: DATE_FORMAT_STYLE_DMY
  },
  {
    label: <DateFormatOption dateFormat={"yyyy-MM-dd"} />,
    value: DATE_FORMAT_STYLE_YMD
  }
]);
